import React from 'react';
import { Modal } from 'antd';
import type { KbStore } from './kb-store';
import type { UserInfo } from '@/common/login-info';
import KbTreeModalContent from './KbTreeModalContent';

const KbNodeModal = (props: {
  store: KbStore;
  open: boolean;
  cancel: () => void;
  confirm: () => void;
  userInfo: UserInfo;
}) => {
  const onAfterOpenChange = (open: boolean) => {
    if (!open) {
      props.cancel()
    }
  }
  return (
    <Modal
      open={props.open}
      title={null}
      footer={null}
      width={416}
      className="file-tree-modal"
      afterOpenChange={onAfterOpenChange}
      onCancel={props.cancel}
    >
      <KbTreeModalContent
        store={props.store}
        title='基于知识库问答'
        cancel={props.cancel}
        userInfo={props.userInfo}
        confirm={props.confirm}
      />
    </Modal>
  );
};

export default KbNodeModal;
